/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Alerts } from "@components/common/AlertModal";
import axios, { AxiosError } from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../store/reducer";
import { colors, Title1, Title2 } from "@utils/ui_palette";
import { useNavigate, useParams } from "react-router-dom";
import { useSearchParams } from "react-router-dom";
import Patterns from "@components/Patterns";
import CountModule from "@components/CountModule";
import Grammar from "@components/Grammar";
import Sentence from "@components/Sentence";
import ImageModule from "@components/ImageModule";
import Colors from "@components/Colors";
import InterView from "@components/InterView";
import DefaultModule from "@components/DefaultModule";

interface IScore {
  section_type: string;
  min_range: number;
  max_range: number;
  point: number;
}

export interface IModule {
  id: number;
  question: string;
  anwser: string;
  choice: string[] | null;
  question_image: null | string;
  score: number;
  answer_submit: string;
  answer_s3: string;
  answer_id: string;
}

interface ISection {
  title: string;
  type: string;
  section_id: string;
  grade_type: string;
  content: string;
  order: number;
  section_score: number;
  section_item: IModule[];
}

interface IReport {
  id: number;
  title: string;
  section_items: ISection[];
}

interface IQuater {
  comments: string;
  save_gb: number;
  profile_id: number;
}

function AssessmentDetail() {
  const navigation = useNavigate();
  const { id } = useParams();
  let [searchParams] = useSearchParams();
  const grade_type = searchParams.get("grade_type");
  const accessToken = useSelector(
    (state: RootState) => state.user.userInfo.accessToken
  );
  const [isCommnet, setCommnet] = useState<boolean>(false);
  const [commentsText, setCommentsText] = useState<string>("");
  const [commentsLoading, setCommentsLoading] = useState<boolean>(false);
  const [commentsValid, setCommentsValid] = useState<boolean>(true);
  const [quater, setQuater] = useState<IQuater | null>(null);
  const [report, setReport] = useState<null | IReport[]>(null);
  const [totalScore, setTotalScore] = useState<number>(0);

  const handleChangeCommnets = useCallback(
    (event) => {
      const { value } = event.target;

      if (value.trim() !== "") {
        setCommentsValid(false);
      }
      setCommentsText(value.trim());
    },
    [setCommentsText]
  );

  const commentsSubmit = useCallback(async () => {
    setCommentsLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_API}/admin/comments/${id}`,
        {
          comments: commentsText,
          total_score: totalScore,
        },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } catch (error) {
      console.log(error);
    } finally {
      setCommentsLoading(false);
      setCommnet(false);
      getProfileReport();
    }
  }, [commentsText, totalScore, setCommentsLoading]);

  const getModuleScore = useCallback(async (module: ISection) => {
    let count: number = 0;

    if (
      module.type === "Uppercase" ||
      module.type === "Lowercase" ||
      module.type === "Write_to_10" ||
      module.type === "Count_to_10" ||
      module.type === "Write_to_20" ||
      module.type === "Count_to_20" ||
      module.type === "Write_to_30" ||
      module.type === "Count_to_30" ||
      module.type === "Count_to_40" ||
      module.type === "Count_to_50"
    ) {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/accessement/score/${module.type}`
        );

        const scoreCount = module.section_item.filter((item) => {
          return item.anwser === item.answer_submit;
        }).length;

        const getScroe =
          data.score.find(
            (score: IScore) =>
              score.min_range <= scoreCount && score.max_range >= scoreCount
          ).point || 0;

        return getScroe ? getScroe : 0;
      } catch (error) {
        console.log(error);
      }
    }

    if (module.type === "Word" || module.type === "Sentence") {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}/accessement/score/${module.type}`
        );

        module.section_item.forEach(async (item) => {
          const getScroe =
            data.score.find(
              (score: IScore) =>
                Number(score.min_range) <= Number(item.answer_submit) &&
                Number(score.max_range) >= Number(item.answer_submit)
            )?.point || 0;

          count += getScroe ? getScroe : 0;
        });

        return count;
      } catch (error) {
        console.log(error);
      }
    }

    module.section_item.forEach(async (item) => {
      if (module.type === "Grammar2") {
        const anwserArr = item.anwser.toLocaleLowerCase().split(",") || "";

        const getAnwser =
          anwserArr.filter((anwser) =>
            item.answer_submit?.toLocaleLowerCase()?.includes(anwser)
          ).length || 0;

        count += getAnwser;
      }

      if (module.type === "Create_pattern") {
        // console.log(item.answer_submit);
        if (item.answer_submit === "") {
          return 0;
        }
        const anwser = item.answer_submit ? item.answer_submit.split(",") : "";
        const anwser1 = anwser.slice(0, 2).toString();

        const anwser2 = anwser.slice(2, -2).toString();
        const anwser3 = anwser.slice(4).toString();

        if (anwser1 === anwser2 && anwser1 === anwser3) {
          count += item.score;
          return;
          // console.log(module.type, count);
        }

        const anwser4 = anwser.slice(0, 3).toString();
        const anwser5 = anwser.slice(3).toString();

        if (anwser4 === anwser5) {
          count += item.score;
        }
      }

      if (module.type === "Letter_sound" || module.type === "Letter_name") {
        if (Number(item.answer_submit) > 60) {
          count += item.score;
        }
      }

      if (
        item.answer_submit !== "" &&
        item.anwser.toString().toLocaleLowerCase().trim() ===
          item.answer_submit?.toString().toLocaleLowerCase().trim()
      ) {
        count += item.score;
      }
    });

    return count;
  }, []);

  const getProfileReport = useCallback(async () => {
    if (!grade_type || !id) {
      return;
    }

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/admin/assessment-detail/${id}`,
        { type: grade_type },
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      const setArr = data.accessement.reduce(
        (set: ISection[], sections: IReport) => {
          sections.section_items.forEach((data) => {
            set.push(data);
          });

          return set;
        },
        []
      );

      const result = await Promise.all(
        setArr.map(async (section: ISection) => {
          const score = (await getModuleScore(section)) || 0;

          return {
            type: section.type,
            score: score,
          };
        })
      );

      const totalScore = result.reduce((acc, cur) => {
        return acc + cur.score;
      }, 0);

      const completeArr = data.accessement.map((sections: IReport) => {
        const getArr = sections.section_items.map((item) => {
          const itemScore =
            result.find((data) => data.type === item.type).score || 0;
          return {
            ...item,
            section_score: itemScore,
          };
        });

        return {
          ...sections,
          section_items: getArr,
        };
      });

      setTotalScore(totalScore);
      setReport(completeArr);
      setQuater(data.quater);
      setCommentsText(data.quater.comments);
    } catch (error) {
      const errorResponse = (error as AxiosError).response;

      if (errorResponse && (errorResponse.data as any).message) {
        Alerts.show({
          title: (errorResponse.data as any).message,
        });

        navigation("/assessment");
      }
    }
  }, [accessToken, setReport, setQuater, setCommentsText]);

  const handleCallback = useCallback(
    async (item: IModule, type: string, answer?: any) => {
      // ${process.env.REACT_APP_API}
      console.log(item);
      console.log(report);
      if (!quater) {
        return;
      }
      try {
        await axios.post(
          `${process.env.REACT_APP_API}/admin/answer`,
          {
            id: item.answer_id,
            sum_id: id,
            answer_submit:
              type === "Create_pattern" ? "00,00,00,00,00,00" : answer,
            answer_s3: item.answer_s3,
            paper_id: item.id,
            profile_id: quater.profile_id,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );

        getProfileReport();
      } catch (error) {
        const errorResponse = (error as AxiosError).response;

        if (errorResponse && (errorResponse.data as any).message) {
          Alerts.show({
            title: (errorResponse.data as any).message,
          });
        }
      }
    },
    [quater, report]
  );

  useEffect(() => {
    getProfileReport();
  }, []);

  return (
    <>
      {quater && (
        <Container>
          {quater.save_gb === 3 && (
            <CommentBanner>
              You have completed entering comments!
              <PrintButton
                onClick={() =>
                  navigation(`/assessment-report/${id}/${grade_type}`)
                }
              >
                Result
              </PrintButton>
            </CommentBanner>
          )}

          <PrintArea>
            <TitleBox>
              <Title1 align="left">Assessment Detail</Title1>

              <Total>{totalScore} point</Total>
            </TitleBox>

            {report && (
              <Panel>
                <ReportCardGroup>
                  {report.map((data) => (
                    <ReportItems key={`report-${data.id}`}>
                      <Title1 align="left">{data.title}</Title1>

                      {data.section_items.map((module, index) => (
                        <ReportModules key={`report-${data.id}-${module.type}`}>
                          <Title1 align="left" marginTop={20}>
                            {module.type}
                          </Title1>
                          <ModuleTitleBox>
                            <Title2
                              align="left"
                              marginBottom={20}
                              marginTop={10}
                            >
                              {module.title}
                            </Title2>
                            <ModuleScore>
                              {module.section_score} point
                            </ModuleScore>
                          </ModuleTitleBox>

                          <ModuleBox>
                            {module.section_item.map((item) => (
                              <>
                                {module.type === "Grammar11" && (
                                  <Grammar
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}

                                {(module.type === "Sentence" ||
                                  module.type === "Word") && (
                                  <Sentence
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}

                                {(module.type === "Interview" ||
                                  module.type === "Create_a_story") && (
                                  <InterView
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}

                                {module.type === "Colors" && (
                                  <Colors
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                  />
                                )}

                                {(module.type === "Spelling" ||
                                  module.type === "Blank_letter" ||
                                  module.type === "Consonant" ||
                                  module.type === "Vowel" ||
                                  module.type === "Image_association" ||
                                  module.type === "Missing_letter" ||
                                  module.type === "First_letter" ||
                                  module.type === "Name_the_object" ||
                                  module.type === "Uppercase" ||
                                  module.type === "Lowercase" ||
                                  module.type === "Write_to_10" ||
                                  module.type === "Write_to_20" ||
                                  module.type === "Write_to_30" ||
                                  module.type === "Time" ||
                                  module.type === "Shapes" ||
                                  module.type === "Count_object") && (
                                  <ImageModule
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}

                                {(module.type === "Patterns" ||
                                  module.type === "Create_pattern") && (
                                  <Patterns
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}

                                {(module.type === "Letter_name" ||
                                  module.type === "Letter_sound" ||
                                  module.type === "Make_the_sentence" ||
                                  module.type === "Find_letter" ||
                                  module.type === "Count_to_10" ||
                                  module.type === "Count_to_20" ||
                                  module.type === "Count_to_30" ||
                                  module.type === "Count_to_40" ||
                                  module.type === "Count_to_50") && (
                                  <CountModule
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}

                                {(module.type === "Biggest" ||
                                  module.type === "RC" ||
                                  module.type === "Smallest" ||
                                  module.type === "A_and_S" ||
                                  module.type === "Addition" ||
                                  module.type === "Number_ID" ||
                                  module.type === "Grammar" ||
                                  module.type === "Complete_the_sentence" ||
                                  module.type === "Sequence") && (
                                  <DefaultModule
                                    key={`${module.type}-${item.id}`}
                                    type={module.type}
                                    item={item}
                                    anwserCallback={handleCallback}
                                  />
                                )}
                              </>
                            ))}
                          </ModuleBox>
                        </ReportModules>
                      ))}
                    </ReportItems>
                  ))}
                </ReportCardGroup>
              </Panel>
            )}

            {!isCommnet && (
              <CommentButton onClick={() => setCommnet(true)}>
                Leave a comment
              </CommentButton>
            )}
          </PrintArea>

          <CommentContainer comment={isCommnet}>
            <CommnetBody>
              <CommentTitle>Please write a comment</CommentTitle>
              <TextInputs
                value={commentsText || ""}
                onInput={(event) => handleChangeCommnets(event)}
              />

              <CommnetButtonGroup>
                <CommentSubmit
                  onClick={commentsSubmit}
                  disabled={commentsLoading || commentsValid}
                >
                  Complete
                </CommentSubmit>
                <CommnetCancel onClick={() => setCommnet(false)}>
                  Cancel
                </CommnetCancel>
              </CommnetButtonGroup>
            </CommnetBody>
          </CommentContainer>
        </Container>
      )}
    </>
  );
}
const PrintArea = styled.div`
  @page {
    size: A4;
    margin: 20mm 0;
  }
`;

const PrintButton = styled.button`
  width: 100px;
  height: 50px;
  background-color: ${colors.White};
  border: 1px solid ${colors.Gray50};
  border-radius: 10px;
  font-size: 14px;
  font-weight: bold;
  cursor: pointer;

  &:hover {
    background-color: ${colors.Gray10};
  }
`;

const Container = styled.div`
  width: 1024px;
  padding: 20px;
  position: relative;
`;

const TitleBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Total = styled.div`
  font-size: 30px;
  font-weight: 700;
  color: ${colors.Primary50};
  border: 2px solid ${colors.Primary50};
  width: 200px;
  height: 60px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Panel = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding: 20px;
  border-radius: 12px;
  background-color: ${colors.White};
  border: 1px solid ${colors.Gray30};
  margin-top: 20px;
  box-shadow: 5px 5px 10px ${colors.Gray30};
`;

const ReportCardGroup = styled.div`
  flex-basis: 100%;
`;

const ReportItems = styled.div``;

const ReportModules = styled.div`
  margin-bottom: 40px;
`;

const ModuleScore = styled.div`
  width: 200px;
  margin-left: 20px;
  font-size: 30px;
  font-weight: 700;
  margin-right: 20px;
  color: ${colors.Primary50};
  text-align: right;
`;

const ModuleTitleBox = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

const ModuleBox = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const CommentContainer = styled.div<{ comment: boolean }>`
  position: fixed;
  bottom: 0;
  right: 100px;
  background-color: ${colors.Primary50};
  width: 700px;
  height: ${(props) => (props.comment ? "575px" : 0)};
  overflow: hidden;
  transition: height 0.6s;
  border-radius: 10px 10px 0 0;
`;

const CommnetBody = styled.div`
  padding: 30px;
`;

const CommentButton = styled.div`
  position: fixed;
  bottom: 0;
  right: 100px;
  width: 200px;
  height: 60px;
  background-color: ${colors.Primary50};
  font-size: 18px;
  color: ${colors.White};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px 10px 0 0;
  cursor: pointer;
  transition: all 0.6s;
`;

const CommentTitle = styled.div`
  font-size: 16px;
  color: ${colors.White};
  font-weight: 700;
`;

const TextInputs = styled.textarea`
  width: 100%;
  height: 400px;
  margin-top: 20px;
  border-radius: 8px;
  border: 0;
  padding: 30px;
  font-size: 14px;
  line-height: 1.5;
`;

const CommnetButtonGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
`;

const CommnetCancel = styled.button`
  flex-basis: calc(40% - 10px);
  height: 50px;
  background-color: ${colors.White};
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  color: ${colors.Black};
  font-size: 16px;
  font-weight: 700;
`;

const CommentSubmit = styled.button`
  flex-basis: calc(60% - 10px);
  height: 50px;
  background-color: ${colors.Primary90};
  border: 0;
  border-radius: 8px;
  cursor: pointer;
  color: ${colors.White};
  font-size: 16px;
  font-weight: 700;

  &:disabled {
    background-color: ${colors.Gray30};
  }
`;

const CommentBanner = styled.div`
  width: 100%;
  height: 80px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.Warning20};
  font-size: 18px;
  font-weight: 700;
  color: ${colors.White};
  margin-bottom: 30px;
`;

export default AssessmentDetail;
